module.exports = __webpack_public_path__ + "img/icon_facebook.356ccf53.png";